module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view-title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$route.query.groupName || _vm.attrText.group) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "workgroup-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.m.currentTab
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.workgroup,
      "name": "workgroup"
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowAccountAddWorkgroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Distribute")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.m.batchDel === ''
    },
    on: {
      "click": function($event) {
        _vm.batchDel(_vm.m.batchDel)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Exit")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "memberTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.m.groupWorkgroupList,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.project_name))]), _vm._v(" "), (scope.row.network_id !== -1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.defaultWorkgroup,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-globe",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.desc
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.desc) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Exit")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.m.totalPage > 10 && _vm.m.currentTab === 'workgroup') ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.m.totalPage,
      "current-page": _vm.m.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.m.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a376f12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/team-group-workgroup.vue
// module id = 533
// module chunks = 4 5 6